module.exports = __webpack_public_path__ + "img/headshot-cprovost.a07e0e33.png";